<template>
    <div class="rf-view confirm-promotion-view">
        <NavigationBar :title="$t('confirm.title')">
            <BackButton v-if="canPop" slot="left" @click="pop" />
        </NavigationBar>
        <main>
            <PromotionBox :promotion="promotion" />
            <h1>
                {{ $t('confirm.title') }}
            </h1>
            <GeneralErrorsView :error-box="errorBox" />
            <p class="description">
                {{ $t('confirm.description') }}
            </p>
        </main>

        <FloatingFooter>
            <button class="button secundary full" @click="pop">
                {{ $t('buttons.cancel') }}
            </button>

            <LoadingButton :loading="loading" class="block">
                <button class="button primary full" @click="next">
                    {{ $tc('confirm.button', orderToAllMyClients ? (amount * customerNumber) : amount) }}
                </button>
            </LoadingButton>
        </FloatingFooter>
    </div>
</template>


<script lang="ts">
import { BackButton,FloatingFooter, InputBox, List, ListItem,LoadingButton, NavigationBar, NumberInput,PromotionBox } from "@restofrit/components"
import { Session } from "@restofrit/networking";
import { Customer, OrderSettings, PromotionCustomer } from "@restofrit/structures";
import { AnyDecoder } from "@simonbackx/simple-encoding";
import { ErrorBox, GeneralErrorsView } from "@simonbackx/simple-error-forms";
import { ComponentWithProperties, NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins, Prop } from "vue-property-decorator";

import ConfirmationView from "./ConfirmationView.vue";

@Component({
    components: {
        InputBox,
        GeneralErrorsView,
        NumberInput,
        LoadingButton,
        FloatingFooter,
        NavigationBar,
        List, 
        ListItem,
        PromotionBox,
        BackButton
    },
})
export default class ConfirmPromotionView extends Mixins(NavigationMixin) {
    loading = false

    @Prop({ required: true })
    promotion!: PromotionCustomer

    @Prop({ required: true })
    customer!: Customer

    errorBox: ErrorBox | null = null

    @Prop({ required: true })
    amount!: number

    @Prop({ required: true })
    orderToAllMyClients!: boolean

    @Prop({ required: true })
    customerNumber!: number

    
    async next() {
        if (this.loading) {
            return
        }
        this.loading = true

        try {
            const response = await Session.shared.authenticatedServer.request({
                method: "POST",
                path: "/customers/"+this.customer.id+"/order",
                body: OrderSettings.create({
                    promotion: this.promotion,
                    amount: this.amount,
                    orderToAllMyClients: this.orderToAllMyClients
                }),
                decoder: AnyDecoder // TODO: this is just a temporary solution (so that it doesn't throw an error), until the frontend part will be adjusted
            })
            
            if(response.data && response.data[0]) {
                this.promotion.orders.push(response.data[0])
            }

            this.show({
                components: [
                    new ComponentWithProperties(ConfirmationView, {})
                ],
                animated: true,
                replace: this.navigationController!.components.length - 1,
                force: true
            })
        } catch (e) {
            console.error(e)
            this.errorBox = new ErrorBox(e)
        }
        
        this.loading = false
    }
    
}
</script>

<style lang="scss">
@use '~@restofrit/scss/base/variables.scss' as *;
@use '~@restofrit/scss/base/text-styles.scss' as *;

/* The animation code */
@keyframes rotateCard {
  from {
      transform: scale(0.7, 0.7) rotate(0deg);

      @media (max-width: 50) {
          
      }
  }
  to {
      transform: scale(0.6, 0.6) rotate(7deg);
  }
}

.confirm-promotion-view {
    .promotion-box {
        margin: -10% 0;
        margin-top: -15%;
        transform: scale(0.7, 0.7) rotate(0deg);

        > div {
        box-shadow: 0px 2.5px 20px rgba(0, 0, 0, 0.15);

        }

        & {
            animation-name: rotateCard;
            animation-duration: 1s;
            animation-delay: 0.2s;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
        }
    }
    > main > h1 {
        @extend .style-h1;
        padding-bottom: 5px !important;
    }

    .description {
        @extend .style-description;
        padding: 10px 0;
    }
}
</style>